import {Component, OnInit} from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {ErrorType} from '../../../../model/error-type';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {InputNumberModule} from 'primeng/inputnumber';
import {TranslateModule} from '@ngx-translate/core';
import {MessageComponent} from '../../../../components/generic/message/message.component';
import {Button} from 'primeng/button';
import {InputText} from 'primeng/inputtext';
import {Select} from 'primeng/select';

export interface InputBoxResult
{
  value: any;
  success: boolean;
  dropdownItem: any;
}

@Component({
  standalone: true,
  selector: 'app-input-box',
  templateUrl: './input-box.component.html',
  imports: [
    ReactiveFormsModule,
    InputNumberModule,
    TranslateModule,
    MessageComponent,
    Button,
    InputText,
    Select
  ],
  styleUrls: ['./input-box.component.scss']
})
export class InputBoxComponent implements OnInit
{
  form: UntypedFormGroup;
  errorMsg: ErrorType;
  isSaving: boolean;
  label: string;
  question: string;
  saveLabel: string;
  dropdownItems: any[];
  onlyNumbers: boolean;
  allowEmpty: boolean;

  public static showDialog(dialogService: DialogService, title: string, label: string, defaultValue: any,
                           saveLabel?: string, allowEmpty?: boolean, onlyNumbers?: boolean, question?: string):
    DynamicDialogRef
  {
    return dialogService.open(
      InputBoxComponent,
      {
        header: title,
        width: '600px',
        data: {label, defaultValue, saveLabel, allowEmpty, onlyNumbers, question},
        dismissableMask: true,
        closable: true,
        modal: true,
        styleClass: 'dynamicDialog'
      });
  }
  public static showDropdownDialog(dialogService: DialogService, title: string, label: string, dropdownItems: any[]):
    DynamicDialogRef
  {
    return dialogService.open(
      InputBoxComponent,
      {
        header: title,
        width: '600px',
        data: {label, dropdownItems},
        dismissableMask: true,
        closable: true,
        modal: true,
        styleClass: 'dynamicDialog'
      });
  }

  constructor(public ref: DynamicDialogRef,
              public config: DynamicDialogConfig,
              private formBuilder: UntypedFormBuilder)
  {
    this.label = config.data.label;
    this.question = config.data.question;
    this.dropdownItems = config.data.dropdownItems;
    this.allowEmpty = config.data.allowEmpty;
    this.onlyNumbers = config.data.onlyNumbers;
    if (config.data.saveLabel)
      this.saveLabel = config.data.saveLabel;
  }

  ngOnInit(): void
  {
    this.form = this.formBuilder.group({
      name: new UntypedFormControl(this.config.data.defaultValue, this.allowEmpty ? undefined : Validators.required),
      dropdownItem: new UntypedFormControl('', Validators.required),
    });
  }

  onOkClicked(): void
  {
    console.log('onOkClicked()');

    this.ref.close({
      success: true,
      value: this.form.controls.name.value,
      dropdownItem: this.form.controls.dropdownItem.value
    });
  }

  onCancelClicked(): void
  {
    if (!this.isSaving)
    {
      this.ref.close({
        success: false
      });
    }
  }
}
